/* ================= VAT Calculator ================= */
function vatPriceCalculator(taxFreePrice){
  var taxPrice = (taxFreePrice * 1.0).toFixed(2);
  var s = taxPrice.toString();

  if( s.indexOf(".") > -1 ){
    var decimalPrice = jQuery.makeArray(taxPrice.split('.'));
    var decimalPricePounds = decimalPrice[0];
    var poundArray = decimalPrice[0].split('');
    var decimalArray = decimalPrice[1].split('');
    var secondLastPound = (poundArray.length) - 2;
    var lastPound = poundArray.length - 1;

    // console.log('-->'+decimalPricePounds);

    if( decimalArray[0] <= '8' && decimalArray[0] > 0 ){
      var taxPriceUp = taxPrice;
      var vatVariantPrice = (parseInt(decimalPricePounds)) + 1;
      return vatVariantPrice;
    } else if( poundArray[secondLastPound] == '0' && poundArray[lastPound] == '0' ) {
      var vatVariantPrice = (parseInt(decimalPricePounds));
      return vatVariantPrice;
    }
  } else {
    return (Math.floor(taxFreePrice * 1.0));
  }
}

(function($){
  /* ====================== FRAME ===================== */
  var editorActive = false;

  /* ==================  EDITOR LOADER ================ */
  var frame = {
    sectionOpen: {
      newsletter : function() {newsletterPopup() },
      exitintent : function() { }
    },

    sectionClose: {
      newsletter: function() { ctaModal('close') },
      exitintent: function() { ctaModal('close') }
    },

    blockOpen: {
      meganav: function(editing, param) {meganav(editing, param)  }
    },

    blockClose: {
      meganav: function(editing, param) {meganav(editing, param)  }
    }
  }

  /* =================== EDITOR INIT =================== */
  /* DO SOMETHING WHEN SECTIONS IS ACTIVE */
  $(document).on('shopify:section:load', function(){
    editorActive = true;
  });

  /* SECTION OPENED: CHECK THE OPEN LIST AND DO SOMETHING */
  $(document).on('shopify:section:select', function(evt){
    editorActive = true;

    var sectionName = evt.detail.sectionId;
    if( frame.sectionOpen[sectionName] ){
      frame.sectionOpen[sectionName]();
    }
  });

  /* SECTION CLOSED: CHECK THE OPEN LIST AND DO SOMETHING */
  $(document).on('shopify:section:deselect', function(evt){
    editorActive = true;

    var sectionName = evt.detail.sectionId;
    if( frame.sectionClose[sectionName] ){
      frame.sectionClose[sectionName]();
    }    
  });

  /* BLOCK OPENED: CHECK THE OPEN LIST AND DO SOMETHING */
  $(document).on('shopify:block:select', function(evt){
    editorActive = true;

    var sectionName = evt.detail.sectionId,
            blockEl = $(evt.target);

    if( frame.blockOpen[sectionName] ){
      frame.blockOpen[sectionName](blockEl, 'editing');
    }
  });

  /* BLOCK CLOSED: CHECK THE CLOSED LIST AND DO SOMETHING */
  $(document).on('shopify:block:deselect', function(evt){
    editorActive = true;

    var sectionName = evt.detail.sectionId,
            blockEl = $(evt.target);

    if( frame.blockClose[sectionName] ){
      frame.blockClose[sectionName](blockEl, 'close');
    }
  });

  /* ================== FRONTEND LOADER ================ */
  function themeInit() {
    // CORE MODULE INIT'S
    swatches();

    // CUSTOM MODULE INIT'S
    newsletterPopup();
    stickyHeader();
    ajaxCart();
    meganav();
  };

  themeInit();

  /* ==================== GLOBAL CTA =================== */
  function ctaModal(selector, cName, type) {
    var cookieName = cName,
        cookieType = type,
        $selector  = $(selector);

    setTimeout(function(){
      if( modalState == false ){
        if( !Cookies.get(cookieName) || editorActive==true || cName == null ){
          modalState = cName;
          $selector.addClass('cta--show');
          setTimeout(function(){ $selector.addClass('cta--animate')}, 150);
        }
      }
    }, 600);

    if( selector == 'close' ){
      $('.cta').each(function(){
        $(this).removeClass('cta--animate');
        setTimeout(function(){ $(this).removeClass('cta--show')}, 1500);
      });
    }

    function ctaClose(el) {
      if( cookieType == 'temporary' ){
        Cookies.set(cookieName, 'close-'+cookieName, { expires: 1, path: '/' });
      } else {
        Cookies.remove(cookieName);
        setTimeout(function(){ Cookies.set(cookieName, 'permenant-'+cookieName, { expires: 365, path: '/' })}, 150);
      }
      modalState = false;
      $selector.removeClass('cta--animate');
      setTimeout(function(){ $selector.removeClass('cta--show')}, 1500);
    };

    if(cookieType == 'permenant') { ctaClose() }
    $selector.find('.cta__close').on('click', function(){ ctaClose($selector)});
  };

  /* ================= AJAX NEWSLETTER ================= */
  function newsletterPopup() {
    ctaModal('#newsletter__cta', 'newsletter');

    $('#mc-embedded-subscribe').on('submit', function(e){
      e.preventDefault();

      $.ajax({
        type        : $(this).attr('method'),
        url         : $(this).attr('action'),
        data        : $(this).serialize(),
        cache       : false,
        dataType    : 'json',
        contentType : "application/json; charset=utf-8",
        error       : function(err) { console.log("Could not connect to the registration server. Please try again later, or contact hello@wemakewebsites.com"); },
        success     : function(data) {
          if (data.result != "success") {
            $('.cta').append('<span class="error">Sorry, this email is either incorrect or already exists on our system</span>');
          } else {
            setTimeout(function(){ $('.cta').html('<h1>Thank You</h1><h2>An email has been sent to you to confirm your registration.</h2>')}, 250 );
            setTimeout(function(){ ctaModal('#newsletter__cta', 'newsletter', 'permenant')}, 2900 );
          }
        }
      });
    });
  };


  /* ================= STICKY HEADER ================= */
 /* function stickyHeader() {
    $(window).on('scroll', function(){
      var scrollTop = $(window).scrollTop(),
          $header   = $('.site-header--wrapper');
      console.log(scrollTop);
      if( scrollTop > 150 ){
        $header.addClass('site-header--animate');
      } else {
        $header.removeClass('site-header--animate');
      }
    });
  }; */

 /* function stickyHeader() {
  var lastState = false; 
  var $header   = $('.site-header--wrapper');

  $(window).on('scroll', function(){
    var scrollTop = $(window).scrollTop();

    if (scrollTop > 160 && !lastState) {
      $header.addClass('site-header--animate');
      lastState = true;
    } else if (scrollTop < 140 && lastState) {
      $header.removeClass('site-header--animate');
      lastState = false;
    }
  });
};*/

function stickyHeader() {
  var lastState = false; 
  var $header = $('.site-header--wrapper');

  $(window).on('scroll', function() {
    var scrollTop = $(window).scrollTop();

    // Add class when scrollTop > 150
    if (!lastState && scrollTop > 150) {
      $header.addClass('site-header--animate');
      lastState = true;
    } 
    // Remove class when scrollTop < 130
    else if (lastState && scrollTop < 130) {
      $header.removeClass('site-header--animate');
      lastState = false;
    }
  });
}



  /* ================= AJAX CART ================= */
  function ajaxCart(){
    var storeCurrency = '',
                $form = $('.product-form'),
       $cartToggleBtn = $('.site-header__cart'),
           $cartCount = $('#CartCount'),
       $cartSubmitBtn = $('.product-form__cart-submit span'),
            $cartBody = $('.cart-ajax'),
            $cartList = $('.cart-ajax__list')
             $cartRow = $('cart-ajax__row'),
          $cartRemove = $('.cart-ajax__remove'),
        $cartQuantity = '.cart-ajax__quantity-ico',
      $cartTotalPrice = $('.cart-ajax--total-price'),
           cartOpened = false,
          cartNoItems = $cartCount.attr('data-count');

    function cartBuild() {
      $.getJSON( "/cart.js", function( data ) {
        items = data.items,
        cart  = [];

        $.each(items, function(i, item){
          prodInfo = {
            image         : item.image,
            price         : item.price,
            title         : item.product_title,
            variant_title : item.variant_title,
            quantity      : item.quantity,
            properties    : item.properties,
            key           : item.key
          }
          cart.push(prodInfo);
        });

        $cartList.html('');

        for (var i = 0; i < cart.length; i++) {
          var cartVariantTitle = cart[i].variant_title != null ? cart[i].variant_title : '' ;
          
           var priceVAL = (vatPriceCalculator(cart[i].price))
          var cartImage = '<div class="cart-ajax__image"><img src='+cart[i].image+' /></div>',
              cart_price = theme.Currency.formatMoney(cart[i].price, theme.moneyFormat),
              cartTitle = '<h5>'+cart[i].title+'</h5> <p>'+cartVariantTitle+'</p>',
              cartPrice = '<h5 class="cart-ajax__price" data-key="'+cart[i].key+'"><span class="money itg_ap">'+ cart_price+'</span></h5>',
           cartQuantity = '<div class="cart-ajax__quantity"><span class="cart-ajax__quantity-ico cart-ajax__quantity-ico--minus">-</span><input type="text" value="'+cart[i].quantity+'"><span class="cart-ajax__quantity-ico cart-ajax__quantity-ico--plus">+</span></div>'
             cartRemove = "<a href=# class=cart-ajax__remove>Remove</a>"
               cartData = '<div class="cart-ajax__row" data-line='+(i+1)+'><div class="cart-ajax__data">'+cartImage+cartTitle+cartQuantity+cartPrice+cartRemove+'</div></div>';
        
          $cartList.append(cartData);
          var cartPro = cart[i].properties;
          var cartHandle = cart[i].handle;
          $.each(cartPro, function(index, value){
              if(value == 'remove tax'){
                var price_accurate = theme.Currency.formatMoney(cart[i].price, theme.moneyFormat);
                $(document).find('.cart-ajax__row [data-key="'+cart[i].key+'"]').html('<span class="money">'+price_accurate+'</span>')
              }
          });
        }

        cartOpened = true;
      });
    };

    function cartOpen() {
      cartNoItems = $cartCount.attr('data-count');

      if( cartOpened != true ){ cartBuild(); }
      if ( cartNoItems > 0 ) {
        $cartBody.addClass('cart-ajax--show');
        setTimeout(function(){ 
          $cartBody.addClass('cart-ajax--fadeIn');
        }, 250);
      } else {
        $cartBody.removeClass('cart-ajax--fadeIn cart-ajax--show');
        cartOpened = false;
      }

      $.event.trigger({
        type: "convertCurrency"
      });
    };

    function cartRender() {
      $.getJSON( "/cart.js", function( data ) {
        var cartTotal = data.item_count;
        var cartData = data.items;
        var pushArr = 0;
        for(i = 0; i < cartData.length; i++){
          var c = cartData[i].properties;
          $.each(c, function(index, value){
            if(value == 'remove tax'){
              var originalPrice = cartData[i].line_price;
              var vatPrice = vatPriceCalculator(cartData[i].line_price);
              var finalPrice = vatPrice - originalPrice;
              // pushArr.push(finalPrice);
              pushArr += finalPrice;
            }
          });
        }
        // console.log(moneyFormatter.format(storeCurrency,pushArr))
        var endPrice = data.total_price;
        endPrice = vatPriceCalculator(data.total_price);
        var Finalprice = endPrice - pushArr;
        $cartCount.find('span').html(cartTotal);
        $cartCount.attr('data-count',cartTotal);
        $cartTotalPrice.html(theme.Currency.formatMoney(Finalprice, theme.moneyFormat));
        cartTotal > 0 ? $cartCount.addClass('site-header__cart-count--show') : $cartCount.removeClass('site-header__cart-count--show');
        cartOpen();
      });
    };

    function cartQuantity(el, lineQuantity) {
      var $lineRow = el.parents('.cart-ajax__row'),
            lineNo = $lineRow.data('line');

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + lineQuantity + '&line=' + lineNo,
        dataType: 'json',
        success: function(){
          if ( lineQuantity == 0 ) { $lineRow.addClass('cart-ajax__row--deleted')}
          setTimeout(function(){
            if ( lineQuantity == 0 ) { $lineRow.remove(); }
            cartOpened = false;
            cartRender();
          }, 250);
        }
      });
    };

    
      $cartToggleBtn.on('mouseenter', function(e){
        e.preventDefault();
        cartRender();
      });

      $form.on('submit', function(e){
        e.preventDefault();
        $.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: $('form[action="/cart/add"]').serialize(),
          dataType: 'json',
          success: function(responce){
            cartOpened = false;
            $form.addClass('product-form--submitted');
            $cartSubmitBtn.html("Added to Shopping Bag");
            cartRender();
            setTimeout(function(){
              $cartSubmitBtn.html("Add to Shopping Bag");
              $form.removeClass('product-form--submitted');
            }, 800);
          }
        });
      });

      $(document).on('mouseup', '.cart-ajax__remove', function(e){
        e.preventDefault();
        cartQuantity($(this), 0);
      });

      $(document).on('mouseup', $cartQuantity, function(e){
        e.preventDefault();
        var $input       = $(this).parent().find('input'),
            inputVal     = parseInt($input.val()),
            sendQuantity = 0;

        if( $(this).hasClass('cart-ajax__quantity-ico--plus') ){
          $input.val(inputVal+1);
          sendQuantity = inputVal+1;
        } else {
          if(inputVal-1 != 0){
            $input.val(inputVal-1);
            sendQuantity = inputVal-1;
          }
        }
        cartQuantity($(this), sendQuantity);
      });

      $(document).on('mouseup', function(e){
        if (!$cartBody.is(e.target) && $cartBody.has(e.target).length === 0){ $cartBody.removeClass('cart-ajax--show')}
      });
    
  };
  
  
  /* ================= MEGA NAV ================= */
  function meganav(editing, param){
    var $siteNavList = $('.site-nav li'),
       $siteDropdown = $('.meganav');

    /* SHOW IF EDITING */
    if(editing){
      if( param == 'editing'){
        editing.addClass('meganav__show');
      } else {
        editing.removeClass('meganav__show');
      }
    }

    $siteNavList.on('mouseenter', function(evt) {
      var $parentId     = $(this).data('meganav-parent'),
          $dropdownList = $('.meganav');
      
      $dropdownList.removeClass('meganav__show');

      $dropdownList.each(function(){
        var $childId = $(this).data('meganav-child');
        if( $parentId == $childId ){
          $(this).addClass('meganav__show');
        }
      });

    });

    $siteDropdown.on('mouseleave mousedown', function(e) {
      // Right Click Patch
      if( e.type != 'mousedown' && e.originalEvent.buttons != 2 ){
        $(this).removeClass('meganav__show');
      }
    });
  }
  /* ================= SWATCHES ================= */
  function swatches(){
    $(document).ready(function(){
      $('.swatch').on('click', function(){
        $(this).find('input').prop('checked', true).trigger('change');
      });
    });
  }
})(jQuery);
